// AUTO-GENERATED — clay vite env init (do not edit)
;(function clayViteEnvInit() {
  if (typeof window === "undefined") return;

  var fromKiln = window.kiln && window.kiln.preloadData && window.kiln.preloadData._envVars;
  var existing = window.process && window.process.env;

  var source = (fromKiln && typeof fromKiln === "object")
    ? fromKiln
    : ((existing && typeof existing === "object") ? existing : {});

  window.process = window.process || {};
  window.process.env = Object.assign({}, source, window.process.env || {});
}());
